<template>
  <ListUsers></ListUsers>
</template>

<script type="text/javascript">
  import ListUsers from "../components/ListUsers/ListUsers";

  export default {
    name: "UsersList",
    components: {ListUsers},
    mounted() {
      this.updateLanguage(this.getCurrentLanguage);
    }
  }
</script>